import headerBg2 from '@/assets/images/active/hjwq/newArea-appoint/header/header_bg2.png';
import officeBtn from '@/assets/images/active/hjwq/newArea-appoint/header/btn_05.png';
import loginBtn from '@/assets/images/active/hjwq/newArea-appoint/header/btn_06.png';
import logoutBtn from '@/assets/images/active/hjwq/newArea-appoint/header/btn_10.png';

export const headerConfig = {
  logged_in: {
    background_image: headerBg2,
    main_title_color: '#784434',
    sub_title_color: '#784434',
    tips_color: '#784434',
    game_name: '新仙剑奇侠传之挥剑问情'
  },
  operation_btn: {
    office_website: {
      width: '',
      height: '',
      background_image: '',
      img: officeBtn,
      style: 'top: 0.4rem',
      link: 'https://hjwq.qingcijoy.com/'
    },
    join_active: {
      width: '',
      height: '',
      background_image: '',
      img: officeBtn,
      style: 'top: 0.4rem',
      link: 'https://hjwq.qingcijoy.com/'
    },
    login: {
      width: '',
      height: '',
      background_image: '',
      img: loginBtn,
      style: 'top: 0.4rem'
    },
    logout: {
      width: '',
      height: '',
      img: logoutBtn,
      style: 'top: 0.4rem'
    }
  }
};



// WEBPACK FOOTER //
// ./src/pages/hjwq/newArea-appoint/headerConfig.js